import { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import UploadPdfButton from '@/components/UploadPDFButton/UploadPdfButton';
import routes from '@/routes';

import PDFEditSteps from './PDFEditSteps';

function HowTo() {
	const { t } = useTranslation();
	const location = useLocation();
	const refHowTo = useRef(null);

	useEffect(() => {
		const hashHowTo = routes.howTo.replace(/^\//, '');

		if (location.hash.includes(hashHowTo)) {
			setTimeout(() => {
				refHowTo.current.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
					inline: 'start'
				});
			}, 100);
		}
	}, [location]);

	return (
		<section
			className="container relative z-10 flex justify-center pt-[80px] lg:pt-[146px]"
			ref={refHowTo}
		>
			<div className="flex w-full flex-col items-center gap-12 lg:gap-[68px]">
				<div className="flex max-w-[711px] flex-col items-start gap-4 self-start">
					<h3 className="self-center font-title text-[32px] font-semibold leading-10 lg:text-[56px] lg:leading-[64px]">
						{t('home.howTo.title')}
					</h3>
					<h4 className="text-sm font-normal leading-6 lg:text-base lg:leading-7">
						{t('home.howTo.subtitle')}
					</h4>
				</div>
				<PDFEditSteps />
				<UploadPdfButton
					size="lg"
					className="mb-20 self-start lg:mb-[111px]"
				/>
			</div>
		</section>
	);
}

export default HowTo;
